const config = {
    // CLIENT_SECRET: 'cstO02DNZQNs3NFnzMaPaYBbKdMzIl8nMjYqIMHP',
    CLIENT_SECRET: 'hKdZfCL030pST1CwdRKDp8ZqrLSVYAQEI5gknjRG',
    CLIENT_ID: "2",
    GRANT_TYPE: "password",
}


export default config;